
{
  "familyId": "GET-KOMMA-DEEL",
  "questions": [
    {
      "id": "GET-KOMMA-DEEL-001",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "multiple_choice",
      "question": "Wat is 7,5 ÷ 3?",
      "options": [
        "2,5",
        "2,3",
        "25",
        "4,5"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_delen_heel_getal",
      "variantIndex": 1,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: deel eerst de eenheden, dan de tienden. Stap 1: 7 ÷ 3 = 2 rest 1. Stap 2: 15 tienden ÷ 3 = 5 tienden. Stap 3: Antwoord: 2,5.",
        "distractorExplanations": {
          "0": "Goed! 7,5 ÷ 3 = 2,5. Controleer: 2,5 × 3 = 7,5 ✓.",
          "1": "Veelgemaakte fout: eenheden en tienden apart delen. 7 ÷ 3 ≈ 2,3, maar de rest moet bij de tienden. 7,5 ÷ 3 = 2,5.",
          "2": "Veelgemaakte fout: de komma vergeten. 75 ÷ 3 = 25, maar 7,5 ÷ 3 = 2,5.",
          "3": "Veelgemaakte fout: aftrekken in plaats van delen. 7,5 − 3 = 4,5, maar de vraag is ÷."
        }
      }
    },
    {
      "id": "GET-KOMMA-DEEL-002",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "multiple_choice",
      "question": "Wat is 12,6 ÷ 4?",
      "options": [
        "3,15",
        "3,2",
        "3,6",
        "8,6"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_delen_rest",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: staartdeling met komma. Stap 1: 12 ÷ 4 = 3. Stap 2: 6 tienden ÷ 4 = 1 rest 2. Stap 3: 20 honderdsten ÷ 4 = 5. Stap 4: Antwoord: 3,15.",
        "distractorExplanations": {
          "0": "Goed! 12,6 ÷ 4 = 3,15. Controleer: 3,15 × 4 = 12,6 ✓.",
          "1": "Veelgemaakte fout: de rest bij de tienden negeren. 6 ÷ 4 = 1 rest 2 → die rest wordt 20 honderdsten ÷ 4 = 5.",
          "2": "Veelgemaakte fout: 12 ÷ 4 = 3 en 6 ÷ 4 ≈ 1,5 → 3 + 0,6 = 3,6. Maar je moet correct doorrekenen: 3,15.",
          "3": "Veelgemaakte fout: aftrekken in plaats van delen. 12,6 − 4 = 8,6."
        }
      }
    },
    {
      "id": "GET-KOMMA-DEEL-003",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "multiple_choice",
      "question": "Je verdeelt 9,36 liter sap gelijk over 4 flessen. Hoeveel liter zit er in elke fles?",
      "options": [
        "2,34 liter",
        "2,43 liter",
        "2,3 liter",
        "5,36 liter"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_delen_context",
      "variantIndex": 3,
      "citoDifficulty": 0.36,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: deel stap voor stap. Stap 1: 9 ÷ 4 = 2 rest 1. Stap 2: 13 tienden ÷ 4 = 3 rest 1. Stap 3: 16 honderdsten ÷ 4 = 4. Stap 4: Antwoord: 2,34 liter.",
        "distractorExplanations": {
          "0": "Goed! 9,36 ÷ 4 = 2,34 liter per fles.",
          "1": "Veelgemaakte fout: cijfers omdraaien. 2,34 is correct, niet 2,43.",
          "2": "Veelgemaakte fout: de honderdsten vergeten. 9,36 ÷ 4 = 2,34, niet 2,3.",
          "3": "Veelgemaakte fout: aftrekken in plaats van delen. 9,36 − 4 = 5,36."
        }
      }
    },
    {
      "id": "GET-KOMMA-DEEL-004",
      "familyId": "GET-KOMMA-DEEL",
      "module": "Getalbegrip",
      "tier": 11,
      "levelCode": "E7",
      "group": 7,
      "skill": "kommagetallen",
      "subSkill": "komma_delen",
      "questionType": "multiple_choice",
      "question": "Wat is 0,84 ÷ 7?",
      "options": [
        "0,12",
        "1,2",
        "0,012",
        "0,77"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "komma_delen_klein_getal",
      "variantIndex": 4,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Strategie: deel de tienden en honderdsten. Stap 1: 0 eenheden ÷ 7 = 0. Stap 2: 8 tienden ÷ 7 = 1 rest 1. Stap 3: 14 honderdsten ÷ 7 = 2. Stap 4: Antwoord: 0,12.",
        "distractorExplanations": {
          "0": "Goed! 0,84 ÷ 7 = 0,12. Controleer: 0,12 × 7 = 0,84 ✓.",
          "1": "Veelgemaakte fout: de komma verkeerd plaatsen. 84 ÷ 7 = 12, maar 0,84 ÷ 7 = 0,12.",
          "2": "Veelgemaakte fout: te veel decimalen. 0,84 ÷ 7 = 0,12, niet 0,012.",
          "3": "Veelgemaakte fout: aftrekken in plaats van delen. 0,84 − 0,07 = 0,77."
        }
      }
    }
  ]
}
